import { render, staticRenderFns } from "./ContactIncheonPage.vue?vue&type=template&id=6041de2a&scoped=true"
import script from "./ContactIncheonPage.vue?vue&type=script&lang=js"
export * from "./ContactIncheonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6041de2a",
  null
  
)

export default component.exports